import { useMemo } from "react";
import { Link } from "react-router-dom";

import { EquipmentsList } from "@/features/chats";
import { useTrainerChatOutlet } from "./TrainerChatUserLayout";

import styles from "./TrainerChatEquipmentsPage.module.scss";

export const TrainerChatEquipmentsPage = () => {
  const { profile } = useTrainerChatOutlet();

  const question20Answer = useMemo(() => {
    if (!profile.ancet) {
      return null;
    }
    const answer = profile.ancet.find((item) => item.quest_num === 20);
    return answer?.answer || null;
  }, [profile.ancet]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Link to=".." className={styles.back}>
          ← Назад к клиенту
        </Link>
        <h3>Оборудование клиента</h3>
        <span className={styles.placeholder} />
      </div>

      {question20Answer && (
        <div className={styles.questionAnswer}>
          <div className={styles.questionAnswerLabel}>Ответ на вопрос анкеты (№20):</div>
          <div className={styles.questionAnswerText}>{question20Answer}</div>
        </div>
      )}

      <EquipmentsList equipments={profile.equipments ?? []} />
    </div>
  );
};









